(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["crafty-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cbn-size-guide')) {
  const initialized = new Set();
  customElements.define('cbn-size-guide', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.choices = Array.from(this.querySelectorAll('.csg-size-buttons [data-csg-preview]'));
      this.addEventListener('change', (event) => event.stopPropagation(), { signal });
      this.addEventListener('input', (event) => {
        if (event.target.matches('[data-csg-range]')) this.preview(this.choices[Number(event.target.value)]?.dataset.csgPreview);
      }, { signal });
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button');
        const dialog = this.querySelector('dialog');
        if (!button || !dialog) return;
        if (button.hasAttribute('data-csg-open')) {
          this.querySelectorAll('[data-csg-preview]').forEach((choice) => {
            const option = this.findOption(choice.dataset.csgPreview);
            choice.disabled = !option || option.disabled;
          });
          const current = this.choices.find((choice) => this.findOption(choice.dataset.csgPreview)?.value === this.select?.value);
          this.preview(current?.dataset.csgPreview || '40x50');
          dialog.showModal();
          this.querySelector('.csg-body').scrollTop = 0;
          this.querySelector('[data-csg-close]').focus({ preventScroll:true });
        } else if (button.hasAttribute('data-csg-close')) dialog.close();
        else if (button.dataset.csgPreview) this.preview(button.dataset.csgPreview);
        else if (button.hasAttribute('data-csg-apply')) {
          dialog.close();
          this.selectSize(this.previewSize);
        }
      }, { signal });
      this.querySelector('dialog')?.addEventListener('click', (event) => {
        if (event.target !== event.currentTarget) return;
        const rect = event.currentTarget.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.currentTarget.close();
      }, { signal });
      const picker = this.closest('variant-picker');
      const key = picker?.dataset.productId;
      // Custom keeps Shopify's first (lowest-priced) variant; preserve explicit selections.
      if (!key || key === '7910867271936' || initialized.has(key)) return;
      initialized.add(key);
      const params = new URLSearchParams(location.search);
      if (params.has('variant') || params.has('option_values') || !picker.closest('main')) return;
      customElements.whenDefined('variant-picker').then(() => requestAnimationFrame(() => {
        if (this.isConnected) this.selectSize('40x50');
      }));
    }
    disconnectedCallback() { this.abort?.abort(); }
    get select() { return this.parentElement?.querySelector('select'); }
    findOption(size) {
      return Array.from(this.select?.options || []).find((option) => option.value.replace(/\s/g,'').includes('('+size+'cm)'));
    }
    preview(size) {
      const index = this.choices.findIndex((choice) => choice.dataset.csgPreview === size);
      if (index < 0) return;
      this.previewSize = size;
      const [width, height] = size.split('x').map(Number);
      const label = `${width} × ${height} cm`;
      this.querySelectorAll('[data-csg-preview]').forEach((choice) => choice.setAttribute('aria-pressed', String(choice.dataset.csgPreview === size)));
      const range = this.querySelector('[data-csg-range]');
      range.value = String(index);
      range.setAttribute('aria-valuetext', label);
      this.querySelector('[data-csg-cm]').textContent = label;
      this.querySelector('[data-csg-inches]').textContent = this.choices[index].dataset.csgInchesValue;
      this.querySelector('[data-csg-summary]').textContent = label;
      const apply = this.querySelector('[data-csg-apply]');
      apply.textContent = `${apply.dataset.csgPrefix.trim()} ${label} →`;
      const option = this.findOption(size);
      apply.disabled = !option || option.disabled;
      const x = 230-width/2;
      this.querySelector('[data-csg-canvas]').setAttribute('transform', `translate(${x} ${190-height})`);
      for (const attr of ['picture','outline']) {
        const element = this.querySelector(`[data-csg-${attr}]`);
        element.setAttribute('width', width);
        element.setAttribute('height', height);
      }
      this.querySelector('[data-csg-width-line]').setAttribute('d', `M0 ${height+6}H${width}M0 ${height+3}V${height+9}M${width} ${height+3}V${height+9}`);
      const wt = this.querySelector('[data-csg-width-text]');
      wt.setAttribute('x', width/2); wt.setAttribute('y', height+17); wt.textContent = `${width} cm`;
      this.querySelector('[data-csg-height-line]').setAttribute('d', `M${width+6} 0V${height}M${width+3} 0H${width+9}M${width+3} ${height}H${width+9}`);
      const ht = this.querySelector('[data-csg-height-text]');
      ht.setAttribute('x', width+12); ht.setAttribute('y', height/2+2); ht.textContent = `${height} cm`;
    }
    selectSize(size) {
      const select = this.select;
      const option = this.findOption(size);
      if (!select || !option || option.disabled || select.value === option.value) return;
      select.value = option.value;
      select.dispatchEvent(new Event('change', { bubbles:true }));
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
